import { Injectable } from '@angular/core';
import { OkObject } from '@it2go/types';
import { ProjectWorkAssignInput } from '@libs/types/src/services/input-type/services/project-work-assign.input';
import { ProjectWorkUnassignInput } from '@libs/types/src/services/input-type/services/project-work-unassign.input';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

@Injectable({ providedIn: 'root' })
export class ServiceWorkOfferProjectGqlService extends GqlServiceV2 {

    public assignWorkToProject(input: ProjectWorkAssignInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: ProjectWorkAssignInput!) {
                    workOfferProject {
                        assign(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public unassignWorkFromProject(input: ProjectWorkUnassignInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: ProjectWorkUnassignInput!) {
                    workOfferProject {
                        unassign(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

}
